import React, {useState, useEffect, useRef, useMemo} from "react";
import { Link , useParams, useNavigate, useLocation  } from "react-router-dom";
import Header from "../layouts/Header";
import Footer from "../layouts/Footer";
import {Links} from '../routes/PathLink'
import Input from '../components/ui/input.jsx';
import {
  useIndicesQuery
} from '../data/indices-details';


import Breadcrumb  from "../components/Breadcrumb";
import IndicesTable  from "../components/IndicesTable";
import {APP_URL, APP_NAME} from 'components/config/Common'
import Seo from 'components/seo/seo'
import { BsSearch } from "react-icons/bs";
import RelatedScreens from './related-screens/related-screens'
import YoutubeStockAnalysis from './YoutubeStockAnalysis'

const StockAnalysisVideo = () => {	
	const navigate = useNavigate();
	const {slug} = useParams()
	
	
	const [metaTitle, setMetaTitle] = useState('Know your stocks - detail analysis')
	const [metaDesc, setMetaDesc] = useState('Know your stocks with detailed analysis, key financial metrics, company fundamentals, growth insights, valuation data, and everything you need to make smarter investment decisions.')
	const [user_type, setUser_type] = useState('');
    const [snipetData, setSnipetData] = useState('');

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(50);
    const [orderBy, setOrder] = useState('created_at');
    const [sortedBy, setColumn] = useState('desc');
  
    // SORTING
    const [sortInfo, setSortInfo] = useState({ key: null, order: null });
    const { search } = useLocation();
    const parameters = new URLSearchParams(search);
    let status_p = parameters.get('status');
    let show_p = parameters.get('show');
    const [searchQuery, setSearchQuery] = useState(null);
  
	//console.log("slug",slug);
	const {
		sectors,
        sectorDetails,
        paginatorInfo,
		isLoading,
		error,
	} = useIndicesQuery({ 
        slug,
        limit: pageSize,
        page,    
        orderBy,
        sortedBy,
        search:searchQuery,
	});

const totalPages = Math.ceil(paginatorInfo?.total / pageSize);

const searchForum = (val) => {
      //console.log('sq---', val)
      setSearchQuery(val)
    }


const breadcrumb = [
  {
    name:'Home',
    link:`${process.env.REACT_APP_URL}`,
  },
  {
    name:`Stock Analysis`,
    link:null
  }
]

	return (
		<>
    <Seo 
        title={`${metaTitle} - ${APP_NAME}`}
        desc={metaDesc && metaDesc.substring(0, 200)}
        url={`${APP_URL}/know-your-stocks`}
      />   
		<Header  />        
        <div className="space-y-5 px-5 lg:px-8">
            <Breadcrumb breadcrumb={breadcrumb} />
            <section className="bg-white shadow-sm z-50 rounded-xl p-5">
              
              <YoutubeStockAnalysis />
            </section>
            
        </div>
       
		<Footer />
		
		
		</>
		);
};

export default StockAnalysisVideo;